import gql from 'graphql-tag'

import { Fragment } from './fragment'

export const query = gql`
  ${Fragment}
  query fetchOffer($id: Int!) {
    records: loans_offer_by_pk(id: $id) {
      ...OfferForm
    }
  }
`

export default query
